"use client";

import type { ButtonProps } from "@/app/_ui/components/core/Button";
import { useTranslations } from "next-intl";

import { submitVCApplication } from "@/app/_api/hubspot";
import { FormDialogButton } from "../shared/FormDialogButton";
import { VCForm, type VCFormProps } from "./VCForm";

export interface VCFormDialogButtonProps {
  buttonLabel?: string | null;
  onTriggerClick?: () => void;
  buttonVariant?: ButtonProps["variant"];
  buttonSize?: ButtonProps["size"];
  contentClassName?: string;
  onSubmit?: VCFormProps["onSubmit"];
}

export default function VCFormDialogButton({
  buttonLabel,
  onTriggerClick,
  buttonVariant = "primary",
  buttonSize = "lg",
  contentClassName,
  onSubmit = submitVCApplication,
}: VCFormDialogButtonProps) {
  const t = useTranslations("FormsClientKeys.vc_form.dialog");

  return (
    <FormDialogButton
      buttonLabel={buttonLabel || t("button")}
      title={t("title")}
      description={t("description")}
      successTitle={t("success_title")}
      successMessage={t("success_message")}
      successButton={t("success_button")}
      buttonVariant={buttonVariant}
      buttonSize={buttonSize}
      contentClassName={contentClassName}
      onTriggerClick={onTriggerClick}
      renderForm={({ onSuccess, onCancel }) => <VCForm onSubmit={onSubmit} onSuccess={onSuccess} onCancel={onCancel} />}
    />
  );
}
